import {Component, HostListener, OnInit} from '@angular/core';
import {FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {FestsetzungAngaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'common-ui-festsetzung-vorauszahlungen',
    templateUrl: './festsetzung-vorauszahlungen.component.html',
    styleUrls: ['./festsetzung-vorauszahlungen.component.scss']
})
export class FestsetzungVorauszahlungenComponent extends FormBaseComponent<FestsetzungAngaben> implements OnInit {

    isNotSmallSize: boolean;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                protected readonly messageService: DatevMessageService,
                protected readonly translateService: TranslateService) {
        super(messageService);
    }


    @HostListener('window:resize', ['$event'])
    public onResize(): void {
        this.isNotSmallSize = window.innerWidth > 639;
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.isNotSmallSize = window.innerWidth > 639;
    }

    protected createForm(): void {
        const GELDBETRAG_PATTERN = 'COMMON_UI.VALIDATION.GELDBETRAG_PATTERN';
        const MAX_LENGTH = 12;
        this.form = this.formBuilder.group({
            gewinn: [
                this.data.gewinn,
                [
                    this.validatorService.maxLength(MAX_LENGTH),
                    this.validatorService.required(),
                    this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
                        this.translateService.instant(GELDBETRAG_PATTERN))
                ]],
            gewinnFj: [
                this.data.gewinnFj,
                [
                    this.validatorService.maxLength(MAX_LENGTH),
                    this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
                        this.translateService.instant(GELDBETRAG_PATTERN))
                ]],
            zuVerstEink: [
                this.data.zuVerstEink,
                [
                    this.validatorService.maxLength(MAX_LENGTH),
                    this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
                        this.translateService.instant(GELDBETRAG_PATTERN))
                ]],
            zuVerstEinkFj: [
                this.data.zuVerstEinkFj,
                [
                    this.validatorService.maxLength(MAX_LENGTH),
                    this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
                        this.translateService.instant(GELDBETRAG_PATTERN))
                ]],
            stAnrBetr: [
                this.data.stAnrBetr,
                [
                    this.validatorService.maxLength(MAX_LENGTH),
                    this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
                        this.translateService.instant(GELDBETRAG_PATTERN))
                ]],
            stAnrBetrFj: [
                this.data.stAnrBetrFj,
                [
                    this.validatorService.maxLength(MAX_LENGTH),
                    this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
                        this.translateService.instant(GELDBETRAG_PATTERN))
                ]],
            gewerbeertrag: [
                this.data.gewerbeertrag,
                [
                    this.validatorService.maxLength(MAX_LENGTH),
                    this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
                        this.translateService.instant(GELDBETRAG_PATTERN))
                ]],
            gewerbeertragFj: [
                this.data.gewerbeertragFj,
                [
                    this.validatorService.maxLength(MAX_LENGTH),
                    this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
                        this.translateService.instant(GELDBETRAG_PATTERN))
                ]]
        });
    }
}

